import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { CurrencyDefaultRateListView } from './currency-default-rate-list.view';
import { CurrencyDefaultRateListDataService } from './currency-default-rate-list.data';

interface CurrencyDefaultRateListProps {
	setBusy(isBusy: boolean);
	defaultCurrency: CurrencySummary;
	currencies: CurrencySummary[];
	changeDefaultCurrency: (newDefaultCurrency: CurrencySummary) => Promise<boolean>;
	contextService: any;
}

@observer
export class CurrencyDefaultRateListController extends React.Component<CurrencyDefaultRateListProps, any> {
	protected dataService: CurrencyDefaultRateListDataService;

	title: string = 'Default change';

	@resolve
	protected dialogService: DialogService;

	@resolve
	protected toast: ToastNotifications;

	constructor(props) {
		super(props);
		this.dataService = CurrencyDefaultRateListDataService.make(this.props.contextService);
	}

	@autobind
	protected loadData() {
		this.props.setBusy(true);
		this.dataService.pageSize = 1000;
		this.dataService.addSorting('fromCurrencyId', 'asc', true);
		this.dataService.load(query => query)
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => this.props.setBusy(false));
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		return (
			<CurrencyDefaultRateListView
				title={this.title}
				model={this.dataService}
				setBusy={this.props.setBusy}
				currencies={this.props.currencies}
				changeDefaultCurrency={this.props.changeDefaultCurrency}
				defaultCurrency={this.props.defaultCurrency}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/currency-default-rates/list/currency-default-rate-list.controller.tsx